import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["offset"];

  get widget() {
    return document.querySelector('.open-table-widget');
  }

  get mobileWidget() {
    return document.querySelector('.cta-widget--mobile');
  }

  connect() {
    this.updatePosition();
    window.addEventListener('resize', this.updatePosition);
  }

  disconnect() {
    window.removeEventListener('resize', this.updatePosition);
  }

  updatePosition = () => {
    const height = this.offsetTarget.offsetHeight;
    if (window.innerWidth >= 1200 && height > 90) {
      const heightOffset = height - 90;
      this.widget.style.top = `${532 + heightOffset}px`;
    } else if (window.innerWidth >= 700 && height > 84) {
      const heightOffset = height - 83;
      this.mobileWidget.style.top = `calc(60vh + 110px + ${heightOffset}px)`;
    } else if (window.innerWidth < 700 && height > 84) {
      const heightOffset = height - 83;
      this.mobileWidget.style.top = `calc(75vh + 110px + ${heightOffset}px)`;
    } else {
      this.mobileWidget.style.top = ''
    }
  }
}